<template>
    <v-card>
        <v-card-title>
            <search v-model="search" />
            <v-spacer></v-spacer>
            <v-dialog persistent v-model="editDialog" max-width="500px">
              <Form v-model="model" @assign="editUser($event.value)">
                <template v-slot:header>
                  <v-spacer></v-spacer>
                  <v-btn @click="editDialog=false" icon text>
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
                <template v-slot:actions>
                  <v-btn @click="editDialog=false">Cancel</v-btn>
                  <v-btn color="red white--text" @click="deleteUser(model)">Delete</v-btn>
                </template>
              </Form>
            </v-dialog>
            <v-dialog persistent v-model="syncDialog" max-width="500px">
              <v-card>
                <v-toolbar dark color="primary">
                  <v-toolbar-title>Synchronise User with Microsoft Entra</v-toolbar-title>
                  <slot name="header"></slot>
                </v-toolbar>
                <v-card-text>
                  <span>This my take a long time, and will run in the background</span>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="syncDialog=false">Cancel</v-btn>
                  <v-btn color="primary" @click="syncUsers">Start</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog persistent v-model="importDialog" max-width="800px">
              <import @import="openCreate($event.value)">
                <template v-slot:header>
                  <v-spacer></v-spacer>
                  <v-btn @click="importDialog=false" icon text>
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
                <template v-slot:actions>
                  <v-btn @click="importDialog=false">Cancel</v-btn>
                </template>
              </import>
            </v-dialog>
            <v-menu>
              <template v-slot:activator="{ on }">
                <v-btn small tile v-on="on" class="mr-4">
                  <v-icon>save_alt</v-icon>&nbsp;Export
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="exportCsv()">
                  <v-list-item-title>
                    <v-icon>grid_on</v-icon>&nbsp;Excel (CSV)
                    <v-chip x-small>limit {{maxRowsPerCsv}} rows</v-chip>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-btn color="secondary" class="mr-4" @click="openSync">Sync</v-btn>
            <v-btn color="primary" @click="openImport">Import</v-btn>
        </v-card-title>

        <v-data-table
            :items="users"
            :items-per-page="options.itemsPerPage"
            :headers="headers"
            :search="search"
            :loading="$wait.is(['loading users'])"
            :footer-props.sync="footerProps"
            :options.sync="options"
        >
            <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
            <template v-slot:item="props">
                <tr @click="userIsFleetManager ? openEdit(props.item) : null">
                    <td>{{props.item.employeeNumber}}</td>
                    <td>{{props.item.displayName}}</td>
                    <td>{{props.item.mail}}</td>
                    <td>{{props.item.department}}</td>
                    <garages-chip-list v-bind:value="props.item.garageNames" v-bind:display-count="3"></garages-chip-list>
                    <roles-chip-list v-bind:value="props.item.roleNames" v-bind:display-count="3"></roles-chip-list>
                    <td>{{ props.item.hasPIN ? 'Yes' : 'No' }}</td>
                    <td></td>
                    <td width="76px" class="pl-0 d-flex" v-if="userIsFleetManager">
                      <v-btn @click="openEdit(props.item)" icon>
                          <v-icon>edit</v-icon>
                      </v-btn>
                    </td>
                </tr>
            </template>
            <template v-slot:no-results>
                <v-layout row align-center>
                    <v-flex>No matching records found</v-flex>
                </v-layout>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import Form from './Form.vue';
import Import from './Import.vue';
import Search from '../Search.vue';
import Users from './UsersClient.vue';
import GarageLocations from '../GarageLocations/GarageLocationsClient.vue';
import GaragesChipList from '../GarageLocations/ChipList.vue';
import {RolesStore} from '@/stores/RoleStore';
import RolesChipList from '../Users/ChipList.vue';
import moment from 'moment';
import { DateFormat } from '@/plugins/date-filter';
import DownloadHelper from '@/lib/DownloadHelper';

export default {
    components: {
        Form,
        Import,
        Search,
        GaragesChipList,
        RolesChipList
    },
    mixins: [Users, GarageLocations],
    data() {
        return {
            users: [],
            editDialog: false,
            deleteDialog: false,
            importDialog: false,
            syncDialog: false,
            search: '',
            maxRowsPerCsv: 4000,
            options: {
                itemsPerPage: 10,
                sortBy: ['displayName']
            },
            footerProps: {
                itemsPerPageOptions: [10, 50, 100]
            },
            headers: [
                { text: 'Employee Number', value: 'employeeNumber' },
                { text: 'Name', value: 'displayName' },
                { text: 'Email', value: 'mail' },
                { text: 'Department', value: 'department' },
                { text: 'Garage Address', value: 'garageNames' },
                { text: 'Roles', value: 'roleNames' },
                { text: 'PIN', value: 'hasPIN' },
                {}
            ],
            model: {}
        };
    },
    methods: {
        async openSync() {
            this.syncDialog = true;
        },
        async openEdit(user) {
            this.model = {};
            this.editDialog = true;
            this.model = await this.getUser(user.id);
        },
        async openImport() {
            this.importDialog = true;
        },
        async editUser(user) {
            await this.updateUser(user);
            var users = await this.getUsers();
            this.users = this.convertGarages(users);
            this.editDialog = false;
        },
        async deleteUser(user) {
          this.$confirmCancel.show(`Delete User?`, `<p>This will permanently delete ${user.givenName}</p>`, 'Delete it');
          var confirmHandler = async (confirmed) => {
            this.$confirmCancel.$off('confirm-cancel', confirmHandler);
            if (!confirmed) {
              this.editDialog = false;
              return;
            }

            await this.removeUser(user);
            var users = await this.getUsers();
            this.users = this.convertGarages(users);
            this.editDialog = false;
          };
          this.$confirmCancel.$on('confirm-cancel', confirmHandler);
        },
        async openCreate(user) {
          this.importDialog = false;
          this.model = user;
          this.editDialog = true;
        },
        syncUsers() {
            this.syncDialog = false;
            this.$api.get(`users/sync`);
        },
        convertGarages(users) {
            for (let u of users) {
                u.garageNames = this.garages.filter(g => u.garages.find(x => x === g.id)).map(x => x.location);
                u.roleNames = RolesStore.data.roles.filter(r => u.roles.find(x => x === r.id)).map(x => x.displayName);
            }
            return users;
        },
        exportCsv() {
            const data = this.users;
            const rows = data.slice(0, this.maxRowsPerCsv).map(x => [
                x.employeeNumber,
                x.displayName,
                x.mail,
                x.department,
                (x.garageNames || []).join(', '),
                (x.roleNames || []).join(', '),
                x.hasPIN ? 'Yes' : 'No'
            ]);
            const csv = DownloadHelper.makeCsv([
                'Employee Number',
                'Name',
                'Email',
                'Department',
                'Garage Address',
                'Roles',
                'Has PIN'
            ], rows);
            DownloadHelper.download(`Users_${moment().format(DateFormat.Canonical)}.csv`, new Blob([csv]));
        }
    },
    async mounted() {
        await this.getGarageSelections();
        var users = await this.getUsers();
        this.users = this.convertGarages(users);

        if (this.userIsFleetManager) {
            this.headers.push({ value: 'id' }); // add edit column
        }
    }
};
</script>
